import React, { useState } from 'react';
import { RichText } from 'prismic-reactjs';
import Shape from '../images/shapes/tick.svg';
import './layout.css';
import { H1, P } from './TahoraUI/Typography';

const Line = ({
  title,
  free,
  freeText,
  premium,
  premiumText,
  enterprise,
  enterpriseText,
  font,
}) => {
  return (
    <tr class="linehov hover:rounded-lg">
      <th
        class="py-5 px-6 w-full text-sm font-normal h-full text-gray-500 text-left flex items-center contents-center"
        scope="row"
      >
        <P style={{ color: 'black', fontSize: '18px', fontFamily: font }}>
          {RichText.asText(title)}
        </P>
      </th>

      <td
        style={{
          borderLeftWidth: '3rem',
          borderRightWidth: '3rem',
          position: 'relative',
        }}
        class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
      >
        {/*            <td class="py-5 px-6 text-center flex justify-center">
         */}{' '}
        {/*<!-- Heroicon name: solid/check -->*/}
        <div
          style={{
            width: '16px',
            display: 'contents',
            justifyContent: 'center',
          }}
          class="h-5 mx-auto "
        >
          {freeText === null ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                position: 'absolute',
                left: '46%',
                top: '37%',
              }}
            >
              {free === true ? <Shape /> : null}
            </div>
          ) : (
            <div className="w-full h-full absolute top-0 left-0 items-center px-2 flex contents-center justify-center">
              <P style={{ color: 'black', fontFamily: font }}>
                {RichText.asText(freeText)}
              </P>
            </div>
          )}
        </div>
        <span class="sr-only">Not included in Basic</span>
      </td>
      <td
        style={{
          borderLeftWidth: '3rem',
          borderRightWidth: '3rem',
          position: 'relative',
        }}
        class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
      >
        {/*<!-- Heroicon name: solid/check -->*/}

        <div style={{ width: '100%' }}>
          {premiumText === null ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                position: 'absolute',
                left: '46%',
                top: '37%',
              }}
            >
              {premium === true ? <Shape /> : null}
            </div>
          ) : (
            <div className="w-full h-full absolute top-0 left-0 items-center px-2 flex contents-center justify-center">
              <P style={{ color: 'black', fontFamily: font }}>
                {RichText.asText(premiumText)}
              </P>
            </div>
          )}
        </div>
      </td>

      <td
        style={{
          borderLeftWidth: '3rem',
          borderRightWidth: '3rem',
          position: 'relative',
        }}
        class="w-1/5 brief5 py-5 px-6  text-center border-solid border-l-8 border-r-0 border-white  mx-2 center text-lg leading-6 font-medium text-gray-900 text-left"
      >
        {/*<!-- Heroicon name: solid/check -->*/}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {enterpriseText === null ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                position: 'absolute',
                left: '46%',
                top: '37%',
              }}
            >
              {enterprise === true ? <Shape /> : null}
            </div>
          ) : (
            <div className="w-full h-full absolute top-0 left-0 items-center px-2 flex contents-center justify-center">
              <P style={{ color: 'black', fontFamily: font }}>
                {RichText.asText(enterpriseText)}
              </P>
            </div>
          )}
        </div>
      </td>
    </tr>
  );
};

export default Line;
